import axios from "axios";
import { ORDER, MOST_ORDERED } from "../../constants/apiLink";

export const apiGetAllMostOrdered = () => {
  const url = ORDER + MOST_ORDERED;
  return axios.get(url).then(result => {
    return result;
  });
};
